import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NewAccountStoreSelectors } from 'apps/console/src/app/root-store/new-account-store';
import { Store } from '@ngrx/store';
import * as RoutesDefinitions from 'apps/console/src/app/routes-definitions';

import { NewAccountStep } from '../enums';

@Injectable({
	providedIn: 'root'
})
export class NewAccountStepGuard implements CanActivate {
	private store = inject(Store);
	private router = inject(Router);

	currentStep$ = this.store.select(NewAccountStoreSelectors.selectCurrentStep);

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
		return this.currentStep$.pipe(
			map((currentStep: NewAccountStep) => {
				const targetStep: NewAccountStep = route.data.step;

				if (
					(currentStep === NewAccountStep.Validation && targetStep === NewAccountStep.Validation)
					|| (currentStep !== NewAccountStep.Validation && currentStep >= targetStep)
				) {
					return true;
				}

				this.router.navigate([RoutesDefinitions.getLoginCallbackFullPath()]);
				return false;
			})
		);
	}
}
